import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseUtils, FuseAnimate} from '@fuse';
import {bindActionCreators} from 'redux';
import ReduxContacts from "../../../../store/actionreducers/apply_medical/contacts";
import ReactTable from "react-table";
import classNames from 'classnames';
import {
    Avatar,
    Icon,
    IconButton,
    Typography
} from '@material-ui/core';
import _ from "lodash";

const styles = theme => ({
    mailList: {
        padding: 0
    },
    mailItem: {},
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {}

});

class ApplyMedicalList extends Component {

    state = {
        selectedContactsMenu: null
    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    openSelectedContactMenu = (event) => {
        this.setState({selectedContactsMenu: event.currentTarget});
    };

    closeSelectedContactsMenu = () => {
        this.setState({selectedContactsMenu: null});
    };

    render() {
        const {classes, contacts, searchText, openEditContactDialog, openRemoveContactDialog} = this.props;
        const data = this.getFilteredArray(contacts, searchText);

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何待審核醫生
                    </Typography>
                </div>
            );
        }

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何待審核醫生"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    className={classNames(classes.root, "-striped -highlight")}
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {
                                if (rowInfo) {
                                    openEditContactDialog(rowInfo.original);
                                }
                            }
                        }
                    }}
                    data={
                        data.sort(function (preVip, currVip) {
                            return currVip.id - preVip.id;
                        })
                    }
                    columns={[
                        {
                            Header: "",
                            width: 64,
                            accessor: "user.avatar.url",
                            Cell: row => {
                                return (<Avatar className="mr-8" alt={row.original.user.name} src={row.value}/>);
                            },
                            className: "justify-center",
                            sortable: false
                        },
                        {
                            Header: "姓名",
                            accessor: "user.name",
                            filterable: true,
                            className: "font-bold"
                        },

                        {
                            Header: "執業縣市",
                            accessor: "city.name",
                            filterable: true
                        },
                        {
                            Header: "服務機構",
                            accessor: "hospital",
                            Cell: row => {
                                const medical = row.original;
                                const hospital = row.value;
                                return (hospital) ? hospital.name : medical.unvalidated_hospital_name;
                            },
                            filterable: true,
                        },
                        {
                            Header: "醫師證號",
                            accessor: "certificate_no",
                            filterable: true,
                        },
                        {
                            Header: "狀態",
                            accessor: "status.name",
                            filterable: true
                        },
                        {
                            Header: "",
                            width: 64,
                            Cell: row => {
                                /*   if (row.original.status.label !== 'enable') return <div className="flex items-center"/>;
                                   else*/
                                return (<div className="flex items-center">
                                    <IconButton
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            openRemoveContactDialog(row.original.id);
                                        }}
                                    >
                                        <Icon>spellcheck</Icon>
                                    </IconButton>
                                </div>)
                            }
                        }
                    ]}
                    defaultPageSize={10}
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getContacts: ReduxContacts.ActionCreator.getContacts,
        openEditContactDialog: ReduxContacts.ActionCreator.openEditContactDialog,
        openRemoveContactDialog: ReduxContacts.ActionCreator.openValidateMedicalDialog,
    }, dispatch);
}

function mapStateToProps({applyMedicalsApp}) {
    return {
        contacts: applyMedicalsApp.contacts.entities,
        selectedContactIds: applyMedicalsApp.contacts.selectedContactIds,
        searchText: applyMedicalsApp.contacts.searchText,
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(ApplyMedicalList)));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/medical/ApplyMedicalList.js